import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import { Checkbox } from "shared/components";
import {
  LeaseStatusBadge,
  LeaseStatusBadgeProps
} from "views/renters/components/Table/LeaseStatusBadge";
import {
  SubscriptionBadgeProps,
  SubscriptionBadge
} from "views/renters/components/Table/SubscriptionBadge";
import { AlgoliaUser } from "views/renters/types";

const columnHelperLedger = createColumnHelper<AlgoliaUser["transactions"][]>();

export const columnsForLedgerTable = [
  columnHelperLedger.accessor("date", {
    header: "Date",
    cell: (el) => (
      <p className="text-sm">
        {el.getValue()
          ? moment(el.getValue() as string).format("MMM DD, YYYY")
          : "--"}
      </p>
    ),
    size: 110
  }),
  columnHelperLedger.accessor("description", {
    header: "Description",
    size: 300
  }),
  columnHelperLedger.accessor("type", {
    header: "Type"
  }),
  columnHelperLedger.accessor("amount", {
    header: "Amount",
    size: 70,
    cell: (el) => (el.getValue() ? `$${el.getValue()}` : "--")
  })
];

export const columnHelperRenters = createColumnHelper<AlgoliaUser>();

export const columnsForRentersTable = [
  columnHelperRenters.accessor("id", {
    header: "",
    // header: ({ table }) => {
    //   return (
    //     <div className="px-1">
    //       <Checkbox
    //         id="header"
    //         {...{
    //           checked: table.getIsAllRowsSelected(),
    //           indeterminate: table.getIsSomeRowsSelected(),
    //           onChange: table.getToggleAllRowsSelectedHandler(),
    //         }}
    //       />
    //     </div>
    //   );
    // },
    size: 40,
    id: "fixed_width checkbox custom_",
    cell: ({ row }) => (
      <div className="px-1 pl-4" onClick={(e) => e.stopPropagation()}>
        <Checkbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler()
          }}
        />
      </div>
    )
  }),
  columnHelperRenters.accessor(
    (row) => `${row.customer.firstName} ${row.customer.lastName}`,
    {
      header: "Name"
    }
  ),
  columnHelperRenters.accessor((row) => row, {
    header: "Property",
    cell: (el) => {
      const property = el.row.original.property;
      const unit = el.row.original.property.unit;

      const address = unit.address1 || property.address1;

      return (
        <>
          <p className="overflow-hidden text-ellipsis  whitespace-nowrap text-sm font-medium text-content-1000">
            {property.name}
          </p>
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-xs text-content-400">
            {address}
          </p>
        </>
      );
    }
  }),
  columnHelperRenters.accessor(
    (row) =>
      row.building && row.unit
        ? `${row.building}, ${row.unit}`
        : row.building || row.unit,
    {
      size: 103,
      header: "Unit"
    }
  ),
  columnHelperRenters.accessor((row) => `$${row.rent}`, {
    header: "Rent",
    size: 80,
    id: "fixed_width rent"
  }),
  columnHelperRenters.accessor((row) => row.endDate, {
    header: "Lease End Date",
    id: "fixed_width lease_end_date",
    size: 125
  }),
  columnHelperRenters.accessor((row) => row.status, {
    header: "Lease Status",
    size: 125,
    id: "fixed_width lease_status",
    cell: (el) => {
      return (
        <LeaseStatusBadge
          status={el.row.original.status as LeaseStatusBadgeProps["status"]}
        />
      );
    }
  }),
  columnHelperRenters.accessor((row) => row, {
    header: "Subscription",
    id: "fixed_width subscription",
    size: 175,
    cell: (el) => {
      return (
        <SubscriptionBadge
          status={
            el.getValue()
              .boomEnrollmentStatus as SubscriptionBadgeProps["status"]
          }
        />
      );
    }
  })
];
